import { render, staticRenderFns } from "./ClientsLogotypes.vue?vue&type=template&id=7d7878a9&lang=html"
import script from "./ClientsLogotypes.vue?vue&type=script&lang=js"
export * from "./ClientsLogotypes.vue?vue&type=script&lang=js"
import style0 from "./ClientsLogotypes.vue?vue&type=style&index=0&id=7d7878a9&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports